import React, { Component } from 'react';
import './App.css';
import Input from './components/Input';


class App extends Component {
  
  render() {
    return (
      <div className="App">
<Input />

      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/todo/App.js